import React from 'react'
import PostVacanciesTable from './CommonVacanciesTable'
export default function REPostVacancies() {

  return (
    <div>
       <PostVacanciesTable
      heading='Post Vacancies (Residential Education)'
      headerName='Post Vacancies (Residential Education)' urlParam='HODS'/>
    </div>
  )
}
